<template lang="pug">
  div.product-inspector.bg-dark(:class="{ 'inspector-visible': visible, 'compact': hasMinimalContent }")
    div(v-if="visible")
      div.bottom-border.d-flex.flex-wrap
        span
          strong {{ product.modelNumber}}
          span.ml-2.no-wrap {{ product.nameDe }}
        strong.ml-2.no-wrap {{ product.variantName }}
        em.ml-4.no-wrap(v-if="product.quantityPerPack > 0") Packung: {{ product.quantityPerPack | decimalFix }} {{ product.quantityUnitName }}
      div.product-ingredients(v-if="hasContent")
        div(v-if="product.description") {{ product.description }}
        div(v-if="product.ingredients") {{ product.ingredients }}
</template>

<script>
export default {
  filters: {
    decimalFix (val) {
      return +val.toFixed(1)
    }
  },
  props: {
    product: {
      type: Object,
      required: false,
      default: () => null
    }
  },
  computed: {
    visible () {
      return this.product !== null
    },
    hasContent () {
      if (!this.product) return false
      const hasDescription = this.product.description && this.product.description.trim().length > 0
      const hasIngredients = this.product.ingredients && this.product.ingredients.trim().length > 0
      return hasDescription || hasIngredients
    },
    hasMinimalContent () {
      return this.visible && !this.hasContent
    }
  }
}
</script>
<style lang="stylus">
  .product-inspector
    overflow-y auto
    position fixed
    left 0
    bottom -170px
    // background rgba(0, 0, 0, 0.75)
    width calc(100% - 400px)
    height 170px
    right 0
    color white
    z-index 997
    transition all 0.25s
    padding 16px

    &.inspector-visible
      bottom 0px

    &.compact
      height 54px

      &.inspector-visible
        bottom 0px

    .product-ingredients
      font-size 75%
      font-variant italic
      max-height 100px
      overflow-y auto

    .sap-id
      font-size 75%
      font-weight bold

    .bottom-border
      border-bottom 1px solid rgba(255, 255, 255, 0.5)
      margin-bottom 4px

  @media all and (max-width: 768px)
    .product-inspector
      width 100%

      &.inspector-visible
        bottom 170px

      &.compact
        height 54px

      &.inspector-visible.compact
        bottom 170px
</style>
